export const ACTION_TYPES = {
  GET_CLAIMS_BY_CLIENT: 'claims/GET_ClAIMS_BY_CLIENT',
  SET_PAGE: 'contract/SET_PAGE',
  RESET_CLAIMS: 'claims/RESET_CLAIMS',
  RESET_CLAIMS_FOR_CONRACT: 'claims/RESET_CLAIMS_FOR_CONRACT',
  UPLOAD_CLAIMS: 'claims/UPLOAD_CLAIMS',
  GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER: 'claims/GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER',
  GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER_FOR_CONTRACT_DETAILS: 'claims/GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER_FOR_CONTRACT_DETAILS',
  DECLARE_SINISTRE_BY_SUBSCRIPTION_NUMBER: 'claims/DECLARE_SINISTRE_BY_SUBSCRIPTION_NUMBER',
  EMPTY_REDIRECT_LINK: 'claims/EMPTY_REDIRECT_LINK',

  // ok
  GET_CLAIM: 'claims/GET_CLAIM',
  GET_PAPER_AND_DOCUMENT: 'claims/GET_PAPER_AND_DOCUMENT',
  GET_CLAIM_SUBSCRIPTION: 'claims/GET_CLAIM_SUBSCRIPTION',
  GET_CLAIM_EVENTS: 'claims/GET_CLAIM_EVENTS',
  GET_BENEFIT: 'claims/GET_BENEFIT',
  Get_Claims_Clients_For_Active_Subscription: 'claims/Get_Claims_Clients_For_Active_Subscription',
};
